import { i18n } from '../i18n';
import router from '../router/index';
import axios from '../axiosMain';
import AssignEnergySupplierToCompany from '@/controllers/Consumption/AssignEnergySupplierToCompany';

const state = {
  access_token: null,
  languages: [
    {
      language_code: 'de',
      name: i18n.t('german'),
    },
    {
      language_code: 'en',
      name: i18n.t('english'),
    },
  ],
  user: null,
  isAuthenticated: false,
  loading: false,
  longLoadingTime: false,
  failedLoginAttempt: false,
  green_button_access_response: null,
};

const getters = {
  user(state) {
    return state.user;
  },
  company(state) {
    return state.user.company.data;
  },
  userScopes(state) {
    return state.user.scopes;
  },
  userScopesCollection(state) {
    return state.user.scopes_collection;
  },
  token(state) {
    return state.access_token;
  },
  isAuthenticated(state) {
    return state.isAuthenticated;
  },
  loading(state) {
    return state.loading;
  },
  longLoadingTime(state) {
    return state.longLoadingTime;
  },
  failedLoginAttempt(state) {
    return state.failedLoginAttempt;
  },
  languages(state) {
    return state.languages;
  },
};

const mutations = {
  authUser(state, userData) {
    state.access_token = userData.access_token;
    state.isAuthenticated = true;
  },
  storeUser(state, user) {
    state.user = user;
    localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem('language', user.language);
  },
  clearAuthData(state) {
    state.access_token = null;
    state.user = null;
    state.isAuthenticated = false;
  },
  setLoading(state, bool) {
    state.loading = bool;
  },
  setLongLoadingTime(state, bool) {
    state.longLoadingTime = bool;
  },
  setFailedLoginAttempt(state, bool) {
    state.failedLoginAttempt = bool;
  },
  setAccessToken(state, token) {
    state.access_token = token;
    localStorage.setItem('access_token', token);
  },
  setGreenButtonAccessResponse(state, response) {
    state.green_button_access_response = response;
    localStorage.setItem('green_button_access_response', JSON.stringify(response));
  },
};

const actions = {
  setLogoutTimer({ commit }, expirationTime) {
    setTimeout(() => {
      commit('clearAuthData');
    }, expirationTime);
  },
  async login({ commit, dispatch }, authData) {
    commit('setLoading', true);
    commit('setLongLoadingTime', false);
    commit('setFailedLoginAttempt', false);
    setTimeout(() => {
      commit('setLongLoadingTime', true);
    }, 5000);
    try {
      let response = await axios.post('/auth/login', authData);
      console.log('response:', response.data);
      commit('authUser', {
        access_token: response.data.accessToken,
      });
      localStorage.setItem('access_token', response.data.accessToken);
      localStorage.setItem('expires_at', response.data.token.expires_at);
      dispatch('setLogoutTimer', response.data.token.expires_at);
      let user = await dispatch('fetchAuthUser');
      commit('setLoading', false);
      commit('setLongLoadingTime', false);
      if (user) router.push({ name: 'dashboard' });
      else commit('setFailedLoginAttempt', true);
      return user;
    } catch (e) {
      commit('setLoading', false);
      commit('setFailedLoginAttempt', true);
      return false;
    }
  },
  clearLocalStorage() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('expires_at');
    localStorage.removeItem('user');
  },
  async tryAutoLogin({ commit }) {
    const access = localStorage.getItem('access_token');
    if (!access) {
      return false;
    }
    return commit('authUser', {
      access_token: access,
    });
  },
  async logout({ commit, dispatch, getters }) {
    commit('setLoading', true);
    try {
      await axios.post(
        '/auth/logout',
        {},
        {
          headers: {
            Authorization: 'Bearer ' + getters.token,
          },
        }
      );
    } catch (e) {}
    await dispatch('clearLocalStorage');
    commit('clearAuthData');
    commit('setFailedLoginAttempt', false);
    commit('setLoading', false);
    localStorage.clear();
    router.push('/login').catch(() => {});
  },
  async fetchAuthUser({ state, commit, dispatch, getters }) {
    if (!getters.token) {
      return false;
    }
    try {
      let response = await axios.get('/user');
      let user = response.data.data;
      commit('storeUser', user);
      return user;
    } catch (e) {
      console.log('Error in fetchAuthUser', e);
    }
  },
  async tryAutoFetchAuthenticatedUser({ commit, dispatch }) {
    let user = JSON.parse(localStorage.getItem('user'));
    if (!user) {
      return dispatch('fetchAuthUser');
    } else {
      commit('storeUser', user);
      return dispatch('tryAutoLogin');
    }
  },
  async fetchPublicAccessToken({ commit, dispatch }) {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const token = urlParams.get('access_token');
    if (token) commit('setAccessToken', token);
    return token;
  },
  async loginWithPge({ commit, dispatch, getters }, payload) {
    console.error('I am in loginWithPge');
    try {
      let res = await axios.post(process.env.VUE_APP_BASE_URL + payload.url, payload);
      let company = await AssignEnergySupplierToCompany.update(5, {
        company_id: getters.company.company_id,
        status: 'connected',
        auth_data: JSON.stringify(res.data),
      });
      commit('setGreenButtonAccessResponse', res.data);
      await router.push({ name: 'electricity' });
    } catch (e) {
      console.error(e);
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
